import type { CreateMapMarkerProps } from "./map-marker.type";
import type { MapMarker } from "../map.type";

import { roundLatLng } from "../map.helper";

export const createMapMarker = ({
  position,
  ...marker
}: CreateMapMarkerProps): MapMarker | null => {
  const lat = roundLatLng(position?.lat);
  const lng = roundLatLng(position?.lng);

  if (lat === 0 && lng === 0) return null;

  return {
    type: "default",
    key: "map-marker",
    name: "",
    position: { lat, lng },
    ...marker,
  };
};
